import { PlayerEvents, PlaybackMode } from '@4tn/core-audio-player-shared';
import PlayerConnectionManager from '@players/services/player-connection-manager';
import EventDispatcher from '@utils/event-dispatcher';
import { type IAudioPlayer } from './types';
import logger from '@utils/logger';
import playerEventHandler from '@players/services/player-event-manager';

class ConnectionManager extends PlayerConnectionManager {
  private outOfBuffer = false;

  constructor(player: IAudioPlayer) {
    super(player);
    EventDispatcher.on(PlayerEvents.STREAM_STALLED, this.onStreamStalled.bind(this));
  }

  public async onNetworkReconnect(): Promise<void> {
    if (!this.outOfBuffer) {
      return;
    }

    try {
      this.sendReconnectingEvent();
      (this.player as IAudioPlayer).load();
      await playerEventHandler(PlayerEvents.STREAM_START, async () => {
        await (this.player as IAudioPlayer).play();
      });
      this.sendReconnectEvent();
    } catch (error) {
      logger.error(error);
    }
    this.outOfBuffer = false;
  }

  private onStreamStalled(): void {
    if (
      this.isOnline() ||
      this.outOfBuffer ||
      !this.player.isPlaying ||
      this.player.playbackMode === PlaybackMode.ON_DEMAND_CLIP
    ) {
      return;
    }
    // handles the case when audio stream is out of buffer
    void (this.player as IAudioPlayer).stop(true);
    this.outOfBuffer = true;
  }
}

export default ConnectionManager;
